import Chart from "react-apexcharts";
import { useTranslations } from "use-intl";
import { SubAccountWorkerDto } from "@/models";

interface IProps {
  workers: SubAccountWorkerDto[];
}

// Online vs offline/dead worker breakdown. Data comes from the existing
// GET /api/v1/pools/sub_account/workers/ endpoint (sub_accounts/api/v1/urls.py)
// - it was never called from the cabinet before this.
export function WorkerDonut({ workers }: IProps) {
  const i18n = useTranslations("cabinet.statistics");
  const online = workers.filter((w) => w.status === "ONLINE").length;
  const offline = workers.length - online;

  if (!workers.length) {
    return <p className="text-muted mb-0">{i18n("workersEmpty")}</p>;
  }

  return (
    <Chart
      type="donut"
      height={220}
      series={[online, offline]}
      options={{
        labels: [i18n("workersOnline"), i18n("workersOffline")],
        colors: ["#0ac18f", "#e05656"],
        legend: { position: "bottom" },
        dataLabels: { enabled: true },
      }}
    />
  );
}
